import { createAction } from 'redux-act';

// eslint-disable-next-line import/prefer-default-export
export const SET_STORY_STATE = createAction('Update Story State');
export const SET_PAGE_STATES = createAction('Set Page States');
export const SET_PAGE_PROCESSED = createAction(
  'Change a pages state to processed Page States'
);
